import { IssueStatus, Permission } from '@cims-online/shared'
import CIMSFormItem from 'components/CIMSFormItem'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import CIMSTextArea from 'components/CIMSTextArea'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { FormItemProps } from '../types'
import { HelpMessage } from 'utils/constants'

const Response: React.VFC<FormItemProps> = ({ from, to }) => {
  const [disabled, { some }] = useDisabledOptions({
    reason: 'missing permission',
    disabled: !useCheckPermission(Permission.EditIssueResponse),
  })
  if (from === IssueStatus.PendingResponse.id) return null
  return (
    <CIMSFormItem
      help={HelpMessage.Issues.IssueTracker.Response}
      name="response"
      label="Response"
      requiredMessage={
        to === IssueStatus.PendingDisposition.id ||
        to === IssueStatus.PendingClosure.id
          ? true
          : undefined
      }
      disabled={disabled}
    >
      <CIMSTextArea maxLength={2000} disabled={some} />
    </CIMSFormItem>
  )
}

export default Response
